import { Body1, ITypographyComponentProps } from '@cian/ui-kit';
import { IconFinanceArrowBoldDown16, IconFinanceArrowBoldUp16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { IPriceCellValue } from '../../../../../../../types/newbuildingsCompare';
import leadingImage from '../assets/LeadingImage.svg';
import * as style from './styles.css';

export interface IPriceCellDesktopProps {
  data: IPriceCellValue;
}

export const PriceCellDesktop = ({ data }: IPriceCellDesktopProps): React.JSX.Element => {
  let icon: React.JSX.Element;
  let textColor: ITypographyComponentProps['color'];

  switch (data.trend) {
    case 'increase':
      icon = <IconFinanceArrowBoldUp16 color="icon-positive-default" />;
      textColor = 'text-positive-default';
      break;
    case 'decrease':
      icon = <IconFinanceArrowBoldDown16 color="icon-negative-default" />;
      textColor = 'text-negative-default';
      break;
    case 'noChange':
      icon = <img alt="" src={leadingImage} />;
      textColor = 'accent-ghost-primary';
      break;
  }

  return (
    <div className={style['container']}>
      {icon}
      <Body1 color={textColor}>{data.value}</Body1>
    </div>
  );
};
